<ng-container *ngIf="data; else isLoading">
  <div mat-dialog-content fxLayout="column">
    <div class="main-container padding-right-1" fxLayout="column" fxFlex="100" fxLayoutGap="16px">
      <div class="title-section margin-bottom-0" fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
        <div class="font-bold sparro-grey-800">{{ filter ? 'Filters' : 'Arrange by' }}</div>
        <i class="icon-cross font-xs sparro-grey-800 cursor-pointer" (click)="close()"></i>
      </div>

      <ng-container *ngIf="sort">
        <div class="arrange-section" fxFlex="100">
          <div fxLayout="row wrap">
            <mat-button-toggle-group [(ngModel)]="selectedOrder" name="order" aria-label="Order">
              <mat-button-toggle (change)="toggleOrder($event)" *ngFor="let item of order" [value]="item.type">
                <span>{{ item.name }}</span>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="filter">
        <div fxFlex="100" fxLayout="column" fxLayoutGap="16px">
          <p class="margin-0 sparro-grey-800">Organization</p>
          <mat-form-field class="organizations-form-field" appearance="outline">
            <mat-label class="organizer-label">Search Organization</mat-label>
            <input matInput [formControl]="organizationControl" placeholder="title">
            <i matPrefix class="icon-search sparro-grey-800"></i>
          </mat-form-field>
        </div>
        <div class="timeline-section" fxLayout="row" fxFlex="100">
          <div fxLayout="column" fxFlex="100" fxLayoutGap="16px">
            <p class="filter-title margin-0 sparro-grey-800">Status</p>
            <mat-button-toggle-group [(ngModel)]="selectedTimeline" name="timeline" aria-label="Timeline">
              <mat-button-toggle (change)="toggleTimeline($event)" *ngFor="let item of timeline" [value]="item.type">
                <span>{{ item.name }}</span>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
        <div class="tag-input-wrapper" fxFlex="100">
          <div fxLayout="column">
            <div fxLayout="row">
              <mat-form-field class="width-100">
                <mat-select [formControl]="tagControl" placeholder="Category" [multiple]="true" #selectTag>
                  <mat-select-trigger>
                    {{ tagControl.value ? tagControl.value[0]?.name : '' }}
                    <span *ngIf="tagControl.value?.length > 1">+ {{ tagControl.value.length - 1 }}</span>
                  </mat-select-trigger>
                  <mat-option>
                    <ngx-mat-select-search [formControl]="tagSearchControl" [placeholderLabel]="'Search tags'"
                      [noEntriesFoundLabel]="'No results'" [searching]="false" [enableClearOnEscapePressed]="false">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let tag of searchedTags | async" [value]="tag"
                    (click)="setTag(tag);selectTag.close()">
                    {{ tag.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxLayout="column" fxLayoutGap="12px">
              <div *ngIf="selectedTags.length > 0" class="sparro-grey-800 selected-clear-all" fxLayout="row" fxLayoutAlign="space-between start">
                <p class="margin-0">Selected</p>
                <div (click)="clearFilter('tag')" class="clear-filter-btn">
                  <p class="margin-0">Clear all</p>
                </div>
              </div>
              <mat-chip-list fxLayout="row">
                <mat-chip *ngFor="let tag of selectedTags" [selectable]="selectable" [removable]="removable"
                  class="chip-section">
                  {{ tag.name | titlecase }}
                  <i class="icon-cross font-md" (click)="removeTag(tag)" *ngIf="removable"></i>
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </div>
        <div class="location-input-wrapper" fxFlex="100">
          <div fxLayout="column">
            <div fxLayout="row">
              <mat-form-field class="width-100">
                <mat-select [formControl]="locationControl" placeholder="Locations" [multiple]="true" #selectLocation>
                  <mat-select-trigger>
                    {{ locationControl.value ? locationControl.value[0]?.name : '' }}
                    <span *ngIf="locationControl.value?.length > 1">+ {{ locationControl.value.length - 1}}</span>
                  </mat-select-trigger>
                  <mat-option>
                    <ngx-mat-select-search [formControl]="locationSearchControl" [placeholderLabel]="'Search locations'"
                      [noEntriesFoundLabel]="'No results'" [searching]="false" [enableClearOnEscapePressed]="false">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let location of searchedLocations | async" [value]="location"
                    (click)="setLocation(location);selectLocation.close()">
                    {{ location.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxLayout="column" fxLayoutGap="12px">
              <div *ngIf="selectedLocations.length > 0" class="sparro-grey-800 selected-clear-all" fxLayout="row" fxLayoutAlign="space-between start">
                <p class="margin-0">Selected</p>
                <div (click)="clearFilter('location')" class="clear-filter-btn">
                  <p class="margin-0">Clear all</p>
                </div>
              </div>
              <mat-chip-list fxLayout="row">
                <mat-chip *ngFor="let location of selectedLocations" [selectable]="selectable" [removable]="removable"
                  class="chip-section">
                  {{ location.name | titlecase }}
                  <i class="icon-cross font-md" (click)="removeLocation(location)" *ngIf="removable"></i>
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </div>
        <div class="host-section" fxFlex="100">
          <div fxLayout="column" fxLayoutGap="16px">
            <p class="filter-title margin-0 sparro-grey-800">Competition type</p>
            <mat-button-toggle-group [(ngModel)]="selectedShowType" name="show" aria-label="Show type">
              <mat-button-toggle (change)="toggleShow($event)" *ngFor="let item of show" [value]="item.type">
                <span>{{ item.name }}</span>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
        <div class="discipline-input-wrapper" fxFlex="100" fxLayout="column">
          <mat-form-field class="width-100">
            <mat-select [formControl]="disciplineControl" placeholder="Disciplines" [multiple]="true" #selectDiscipline>
              <mat-select-trigger>
                {{ disciplineControl.value ? disciplineControl.value[0].name : '' }}
                <span *ngIf="disciplineControl.value?.length > 1"> + {{ disciplineControl.value.length - 1}}</span>
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search [formControl]="disciplineSearchControl" [placeholderLabel]="'Search disciplines'"
                  [noEntriesFoundLabel]="'No results'" [searching]="false" [enableClearOnEscapePressed]="false">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let discipline of searchedDisciplines | async" [value]="discipline"
                (click)="setDiscipline(discipline);selectDiscipline.close()">
                {{ discipline.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div fxLayout="column" fxLayoutGap="12px">
            <div *ngIf="selectedDisciplines.length > 0" class="sparro-grey-800 selected-clear-all" fxLayout="row" fxLayoutAlign="space-between start">
              <p class="margin-0">Selected</p>
              <div (click)="clearFilter('discipline')"
                class="clear-filter-btn">
                <p class="margin-0">Clear all</p>
              </div>
            </div>
            <mat-chip-list fxLayout="row">
              <mat-chip *ngFor="let discipline of selectedDisciplines" [selectable]="selectable" [removable]="removable"
                class="chip-section">
                {{ discipline.name | titlecase }}
                <i class="icon-cross font-md" (click)="removeDiscipline(discipline)" *ngIf="removable"></i>
              </mat-chip>
            </mat-chip-list>
          </div>
        </div>
        <mat-form-field class="organized-comp-form-field font-xs-static width-100" appearance="outline">
          <mat-label>Editorial</mat-label>
          <input matInput type="text" [disabled]="true">
          <mat-checkbox matSuffix class="competitions-checkbox" (change)="setEditorial($event)" 
            [(ngModel)]="editorial" [color]="'warn'">
          </mat-checkbox>
        </mat-form-field>
        <div class="width-100 date-range" fxLayout="column" fxLayoutGap="16px">
          <div fxLayout="row">
            <p class="margin-0 filter-title sparro-grey-800">Registration date</p>
          </div>
          <uni-date-range-filter (dateRangeOutput)="setDateRange($event)" [placeholder]="registrationPlaceholder"
            [startDate]="registrationStartDate" [endDate]="registrationEndDate"
            [selectedRange]="selectedRegistrationDateRange">
          </uni-date-range-filter>
          <ng-container *ngIf="selectedRegistrationDateRange">
            <p class="sparro-grey-800 margin-0 selected-clear-all">Selected</p>
            <mat-chip-list fxLayout="row">
              <mat-chip [selectable]="selectable" [removable]="removable" class="chip-section font-sm">
                {{ registrationDateRange }}
                <i class="icon-cross font-md" (click)="removeRegistrationDateRange()" *ngIf="removable"></i>
              </mat-chip>
            </mat-chip-list>
          </ng-container>
          <div fxLayout="row">
            <p class="margin-0 filter-title sparro-grey-800">Submission date</p>
          </div>
          <uni-date-range-filter (dateRangeOutput)="setDateRange($event)" [placeholder]="submissionPlaceholder"
            [startDate]="submissionStartDate" [endDate]="submissionEndDate" [selectedRange]="selectedSubmissionDateRange">
          </uni-date-range-filter>
          <ng-container *ngIf="selectedSubmissionDateRange">
            <p class="sparro-grey-800 margin-0 selected-clear-all">Selected</p>
            <mat-chip-list fxLayout="row">
              <mat-chip [selectable]="selectable" [removable]="removable" class="chip-section font-sm">
                {{ submissionDateRange }}
                <i class="icon-cross font-md" (click)="removeSubmissionDateRange()" *ngIf="removable"></i>
              </mat-chip>
            </mat-chip-list>
          </ng-container>
        </div>
      </ng-container>
      <div fxLayout="row" style="justify-content:flex-end" fxFlex="100" fxLayoutGap="24px">
        <uni-navigation-button default="Reset" button_class="secondary" (click)="reset(sort)">
        </uni-navigation-button>
        <uni-navigation-button default="Apply" button_class="primary" (click)="applyFilters()">
        </uni-navigation-button>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #isLoading>
  <div fxLayout="row" fxLayoutAlign="center center" style="height: 200px">
    <uni-loader></uni-loader>
  </div>
</ng-template>
